import { User } from 'libs/user/user.model';
import { MessageGroup } from './messageGroup.model';
import { MessageReactions } from './message-reactions';

export type MessageType = {
  authorId: string;
  message: string;
  date: string;
  trainingId: string;
  trainingCenterId: string;
  messageGroupId?: string;
  toUserId?: string;
  media?: string;
  directUserIds?: string[];
  readBy?: string[];
  reactions?: MessageReactions;
  id?: string;
  participantIds?: string[];
  isArchivedTraining?: boolean;
};

export class Message {
  constructor(
    public authorId: string,
    public message: string,
    public date: string,
    public trainingId: string,
    public trainingCenterId: string,
    public messageGroupId?: string,
    public toUserId?: string,
    public media?: string,
    public directUserIds?: string[],
    public readBy?: string[],
    public reactions?: MessageReactions,
    public id?: string,
    public author?: User,
    public messageGroup?: MessageGroup,
    // Lot 1D (audit 28/10/2026) — dénormalisés à l'écriture pour que les
    // règles de LISTE sur `messages` n'aient plus besoin d'aucun get() :
    // participantIds fige l'audience au moment de l'envoi (direct ou groupe,
    // résolue côté appelant — voir MessengerComponent) ; isArchivedTraining
    // est tenu à jour par une Cloud Function quand la formation bascule
    // archivée/restaurée (voir on-training-write.ts).
    public participantIds?: string[],
    public isArchivedTraining?: boolean,
  ) {}

  static fromObject(data: any): Message {
    return new Message(
      data?.authorId,
      data?.message,
      data?.date,
      data?.trainingId,
      data?.trainingCenterId,
      data?.messageGroupId,
      data?.toUserId,
      data?.media,
      data?.directUserIds,
      data?.readBy,
      data?.reactions,
      data?.id,
      undefined,
      undefined,
      data?.participantIds,
      data?.isArchivedTraining,
    );
  }

  static toObject(message: Message): any {
    const data = {
      authorId: message.authorId,
      message: message.message,
      date: message.date,
      trainingId: message.trainingId,
      trainingCenterId: message.trainingCenterId,
      // Toujours réécrit (pas seulement si défini) : une mise à jour légitime
      // (réaction, readBy) ne doit jamais faire disparaître cette dénormalisation,
      // comme déjà documenté plus bas pour `reactions` (updateBatch = set()).
      participantIds: message.participantIds ?? [],
      isArchivedTraining: message.isArchivedTraining ?? false,
    };

    if (message.messageGroupId) {
      data['messageGroupId'] = message.messageGroupId;
    }

    if (message.toUserId) {
      data['toUserId'] = message.toUserId;
      data['directUserIds'] = [message.toUserId, message.authorId];
    }

    if (message.media) {
      data['media'] = message.media;
    }

    if (message.readBy) {
      data['readBy'] = message.readBy;
    }

    // Must stay listed here: updateBatch writes with set(), which replaces the
    // whole document, so any field missing from this whitelist is destroyed the
    // next time the conversation is marked as read.
    if (message.reactions) {
      data['reactions'] = message.reactions;
    }

    if (message.id) {
      data['id'] = message.id;
    }

    return data;
  }
}
